import { apiInstance, processApiResponse } from "./parent";
const UserAPI = {
  async getUsers() {
    const path = "/user/all";
    const response = await apiInstance.get(path);
    return processApiResponse(response, "get", path);
  },

  async getUser(id) {
    const path = "/user/" + id;
    const response = await apiInstance.get(path);
    return processApiResponse(response, "get", path);
  },

  async addUser(data) {
    const path = "/user";
    const response = await apiInstance.post(path, data);
    return processApiResponse(response, "post", path);
  },

  async updateUser(data) {
    const path = "/user/update";
    const response = await apiInstance.post(path, data);
    return processApiResponse(response, "post", path);
  },

  async addRole(data) {
    const path = "/user/role";
    const response = await apiInstance.post(path, data);
    return processApiResponse(response, "post", path);
  },

  async getRoles() {
    const path = "/user/roles";
    const response = await apiInstance.get(path);
    return processApiResponse(response, "get", path);
  },

  async updatePassword(data) {
    const path = "/user/update/password";
    const response = await apiInstance.post(path, data);
    return processApiResponse(response, "post", path);
  },

  async removeUser(id) {
    const path = "/user/remove/" + id;
    const response = await apiInstance.get(path);
    return processApiResponse(response, "get", path);
  },
};

export default UserAPI;
